import filterKeys from '../../utilities/filterKeys';

export default (props, extra = []) =>
  filterKeys(props, ['router', 'params', 'location', 'routes', ...extra]);



// WEBPACK FOOTER //
// ./src/components/utilities/excludeRouterKeys.js